var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"z-index":"9999","position":"fixed","top":"0","right":"0","left":"0","bottom":"0","background-color":"black","opacity":".4"},style:({ display: _vm.displayOverlay ? 'block' : 'none' })},[_c('div',{staticClass:"text-center loader-big"},[_c('br'),_c('FontAwesomeIcon',{attrs:{"icon":"spinner","spin":""}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20956abc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/OverlayLoader.vue
// module id = null
// module chunks = 